import {
  getUserList,
  SuccessResponse,
  User,
  UserCombinePermissions,
  UserListResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* getUserListRequest(
  self: Self
): Generator<Promise<FlowReturn<UserListResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getUserList();
    const { data, status } = (response as UserListResponse).data;
    if (status.code === 1000) {
      self.users.reset();

      const combinedData = combinePermissions(data);
      self.users.list = cast(combinedData);

      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

const combinePermissions = (data: User[]): UserCombinePermissions[] => {
  const combinedData: UserCombinePermissions[] = data.map((user) => ({
    ...user,
    permissionId: user.permissionId ?? [],
  }));

  return combinedData;
};

export default getUserListRequest;
